// extracted by mini-css-extract-plugin
export default {"form-info-label":"UserGroupForm_form-info-label__1ZJdX"};